import { RecurrenceKind } from "~/shared/enums";
import type { DayOfWeek } from "~/shared/types";

export const SHORT_WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const RECURRENCE_KIND_TO_VALUE_MAP: Map<RecurrenceKind, string> = new Map([
  [RecurrenceKind.DAILY, "day"],
  [RecurrenceKind.WEEKLY, "week"],
  [RecurrenceKind.MONTHLY, "month"],
  [RecurrenceKind.YEARLY, "year"],
]);

export const DAY_OF_WEEK_LETTERS_AND_NUMBERS: [string, DayOfWeek][] = [
  ["Su", 6],
  ["Mo", 0],
  ["Tu", 1],
  ["We", 2],
  ["Th", 3],
  ["Fr", 4],
  ["Sa", 5],
];
